<template>
  <div v-if="social" class="instagram-contact">
    <a :href="social.instagram">
      <img
        class="w-100 h-100"
        src="@/assets/images/instagram.png"
        alt="اینستاگرام"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "InstagramContact",
  computed: {
    social() {
      let homeData = this.$store.getters["front/getHomeData"];
      return homeData ? homeData.settings.social : {};
    },
  },
};
</script>

<style scoped>
.instagram-contact {
  position: fixed;
  bottom: 3%;
  left: 2%;
  z-index: 15;
}
.instagram-contact a {
  display: inline-block;
  width: 100px;
  height: 100px;
}

@media (max-width: 768px) {
  .instagram-contact {
    position: fixed;
    bottom: 8%;
    left: 3%;
    z-index: 15;
  }
  .instagram-contact a {
    display: inline-block;
    width: 80px;
    height: 80px;
  }
}
</style>
